import { useEffect, useState } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Select from "react-dropdown-select";
import "react-tagsinput/react-tagsinput.css";
import { toast } from "react-toastify";
import {
  BusinessDetailsWantToSaleInterface_NEW,
  DocumentDetailsInterface,
  RegistrationIds,
} from "../../../../assets/interface/primeSharkWebsite_interface";
import HelperService from "../../../../Services/HelperService";
import CompoLoader from "../../../ComponentLoader/CompoLoader";
import ErrorComponent from "../../../Common/ErrorComponent";
import WebService from "../../../../Services/WebService";
import CommonScrollbar from "../../../Common/ScrollBar/CommonScrollbar";
import CurrencyInputField from "../../../Common/CurrencyInput/CurrencyInputField";
import { DROPDOWNTYPES } from "../../../../assets/constants/constants";
import {
  dropdownApiNewcall,
  getCountryListAPiCall,
  getProfileJourneyInfo,
} from "../../../../Services/CommonFunction";
import RequiredLabel from "../../../Common/RequiredLabel/RequiredLabel";
import TagsInput from "react-tagsinput";
import InfoIconForKeyword from "../../../Common/info/infoIcon";
import { isWarning } from "../../Helper";
import { useDispatch } from "react-redux";

interface PropsData {
  handleNext: any;
  impIds: RegistrationIds;
  from?: string;
  fields_to_improve?: any;
}
const types = [
  DROPDOWNTYPES.CHOOSE_PROFILE,
  DROPDOWNTYPES.NO_OF_EMPLOYEES,
  DROPDOWNTYPES.TYPE_OF_SALE,
  DROPDOWNTYPES.BUYER_PREFERENCE,
  DROPDOWNTYPES.DEAL_TIMELINE_EXPECTATION,
  // DROPDOWNTYPES.PREFFERED_LOCATION,
  DROPDOWNTYPES.STRATEGIC_ASSETS,
  DROPDOWNTYPES.ASSETS_INCLUDED_IN_SALE,
];

const BusinessDetails_WantToSell = ({
  handleNext,
  impIds,
  from,
  fields_to_improve,
}: PropsData) => {
  const { t } = useTranslation();
  let account_type = impIds?.account_type;
  const [businessDetailData, setBussinessDetailData] =
    useState<BusinessDetailsWantToSaleInterface_NEW>({
      choose_profile: "",
      type_of_business_being_sold: "",
      no_of_employee: "",
      tangible_intangible_assets: "",
      ebitda: "",
      expected_valuation: "",
      loan_and_liability: "",
      asking_price: "",
      buyer_preference: "",
      currency_asking_price: "USD",
      deal_timeline_expectation: "",
      earn_out_deferred_payment: null,
      offer_post_sale: "",
      owner_involvment_level: "",
      preffered_location: "",
      strategic_assets: "",
      team_willing_post_sale: "",
      top_keywords: [],
      type_of_sale: "",
      assets_included_in_sale: "",
      last_year_annual_revenue: "",
      valuation_justification: "",
      choose_profile_other: "",
    });
  const excludedKeys = [
    "latitude",
    "longitude",
    "valuation_justification",
    "assets_included_in_sale",
    "strategic_assets",
    "offer_post_sale",
    "choose_profile_other",
    "last_year_annual_revenue",
    "type_of_business_being_sold",
    "no_of_employee",
    "tangible_intangible_assets",
    "ebitda",
    "expected_valuation",
    "loan_and_liability",
    "buyer_preference",
    "deal_timeline_expectation",
    "earn_out_deferred_payment",
    "owner_involvment_level",
    "preffered_location",
    "team_willing_post_sale",
    "top_keywords",
    "type_of_sale",
    "valuation_justification",
  ];
  const [errorFlag, setErrorFlag] = useState(false);
  const [loader, setLoader] = useState(false);
  const [dropdownData, setDropdownData] = useState<Record<string, any[]>>({});
  const [businessLocationList, setBusinessLocations] = useState<any[]>([]);
  const [apiCallTriggered, setAPICallTriggered] = useState(false);
  const [skipButtonClicked, setSkipButtonClicked] = useState(false);
  let dispatch = useDispatch();
  useEffect(() => {
    if (account_type) {
      if (impIds?.uuid) {
        getBusinessDetails();
      }
      loadDropdowns();
      getCountryList();
    }
  }, [account_type]);
  const getCountryList = () => {
    getCountryListAPiCall("")
      .then((data: any) => {
        let list: any = [];
        if (data.length > 0) {
          list = data.map((item: any) => ({
            flag: item?.flag,
            label: item.title,
            value: item.title,
          }));
        }
        setBusinessLocations(list);
      })
      .catch(() => { })
      .finally(() => { });
  };
  async function loadDropdowns() {
    try {
      const res = await dropdownApiNewcall("want-to-sell", types); // types is an array of expected keys
      const formattedData: Record<string, { label: string; value: any }[]> = {};
      types.forEach((type) => {
        const items = res[type];
        if (Array.isArray(items)) {
          formattedData[type] = items.map((item) => ({
            label: item.title,
            value: item.title,
          }));
        }
      });

      setDropdownData(formattedData);
    } catch (error) { }
  }

  const getBusinessDetails = () => {
    setLoader(true);
    return WebService.getAPI({
      action: `get-business/want-to-sell/${impIds?.business_uuid}`,
      body: null,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          let info = res?.info;
          setBussinessDetailData(
            (prevBusinessDetails: BusinessDetailsWantToSaleInterface_NEW) => ({
              ...prevBusinessDetails,
              loan_and_liability: info?.loan_and_liability,
              choose_profile: info?.choose_profile,
              choose_profile_other: info?.choose_profile_other,
              business_industry:
                info?.business_industry?.length > 0
                  ? info?.business_industry.map((item: any) => ({
                    title: item?.title,
                  }))
                  : [],
              no_of_employee: info?.no_of_employee ?? "",
              ebitda: info?.ebitda,
              tangible_intangible_assets: info?.tangible_intangible_assets,
              type_of_business_being_sold: info?.type_of_business_being_sold,
              asking_price: info?.asking_price ?? "",

              // && info?.exchange_rate
              //   ? (
              //       Number(info.asking_price) * Number(info.exchange_rate)
              //     ).toFixed(2)
              //   : "",

              buyer_preference: info?.buyer_preference ?? null,
              currency_asking_price: "USD",
              deal_timeline_expectation: info?.deal_timeline_expectation,
              earn_out_deferred_payment: info?.earn_out_deferred_payment
                ? info?.earn_out_deferred_payment?.toString()
                : null,
              offer_post_sale: info?.offer_post_sale
                ? info?.offer_post_sale?.toString()
                : null,
              owner_involvment_level: info?.owner_involvment_level
                ? info?.owner_involvment_level?.toString()
                : null,
              preffered_location: info?.preffered_location,
              strategic_assets: info?.strategic_assets,
              team_willing_post_sale: info?.team_willing_post_sale
                ? info?.team_willing_post_sale?.toString()
                : null,
              top_keywords:
                info?.top_keywords?.length > 0
                  ? info?.top_keywords.map((item: any) => ({
                    title: item?.title,
                  }))
                  : [],
              type_of_sale: info?.type_of_sale,
              expected_valuation: info?.expected_valuation ?? "",
              //  && info?.exchange_rate
              //   ? (
              //       Number(info.expected_valuation) *
              //       Number(info.exchange_rate)
              //     ).toFixed(2)
              //   : "",
              assets_included_in_sale: info?.assets_included_in_sale,
              last_year_annual_revenue: info?.last_year_annual_revenue ?? "",
              // && info?.exchange_rate
              //   ? (
              //       Number(info.last_year_annual_revenue) *
              //       Number(info.exchange_rate)
              //     ).toFixed(2)
              //   : "",
              valuation_justification: info?.valuation_justification,
            }),
          );
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        WebService.removeLoader("save_basic_details");
        return error;
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const handleSaveBusinessDetails = (flag: boolean) => {
    if (HelperService?.checkFormEmptyFields(businessDetailData, excludedKeys)) {
      setErrorFlag(true);
      return;
    }
    //  else if (!valuationReport?.file_name) {
    //   setErrorFlag(true);
    //   return;
    // }
    else {
      setErrorFlag(false);
    }
    handleUpdateBusinessDetailsApiCall(flag);
  };

  const handleUpdateBusinessDetailsApiCall = (flag: boolean) => {
    if (flag) WebService.addLoader("skip_basic_details");
    else WebService.addLoader("save_business_details");
    setAPICallTriggered(true);
    return WebService.putAPI({
      action: `set-business/want-to-sell/${impIds?.business_uuid}`,
      body: businessDetailData,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          toast.success(res.message);
          if (from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS") {
            getProfileJourneyInfo(
              impIds?.account_type?.toLocaleLowerCase(),
              impIds?.business_uuid,
              dispatch,
            );
          }
          handleNext(res);
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      })
      .finally(() => {
        if (flag) WebService.removeLoader("skip_basic_details");
        else WebService.addLoader("save_business_details");
        setAPICallTriggered(false);
      });
  };

  const handleChange = (e: any) => {
    let { name, value } = e.target;
    setBussinessDetailData(
      (prevBusinessDetails: BusinessDetailsWantToSaleInterface_NEW) => ({
        ...prevBusinessDetails,
        [name]: value,
      }),
    );
  };
  const handleChangeCurrency = (type: string, value: string) => {
    setBussinessDetailData(
      (prevBusinessDetails: BusinessDetailsWantToSaleInterface_NEW) => ({
        ...prevBusinessDetails,
        [type]: value,
      }),
    );
  };
  const handleArrayValueChange = (value: any[], key: string) => {
    setBussinessDetailData(
      (prevDetails: BusinessDetailsWantToSaleInterface_NEW) => ({
        ...prevDetails,
        [key]: Array.isArray(
          prevDetails[key as keyof BusinessDetailsWantToSaleInterface_NEW],
        )
          ? value.map((item) => ({ title: item?.value }))
          : value[0]?.value || "",
      }),
    );
  };
  const uploadFile = (event: any) => {
    const selectedFiles = event.target.files;

    let maxSizeFile = false;
    Array.from(selectedFiles).map((file: any) => {
      if (file.size > 10 * 1024 * 1024) {
        maxSizeFile = true;
        toast.error("Maximum file size 10 mb");
        return;
      }
    });
    if (maxSizeFile) {
      return;
    }

    if (selectedFiles && selectedFiles.length > 0) {
      handleUploadFile(selectedFiles[0], event.target.name);

      event.target.value = null;
    }
  };

  async function handleUploadFile(file: any, type: string) {
    await WebService.uploadAPI({
      action: `upload-valuation-report/${impIds?.business_uuid}`,
      body: { type: "VALUATION_REPORT" },
      _file: file,
      key: "file",
    })
      .then((res: any) => {
        if (res?.status) {
          toast.success(res?.message);
          // setValuationReport({
          //   title: res?.path,
          //   file_name: res?.path,
          //   type: "VALUATION_REPORT",
          //   file_title: "",
          // });
        } else {
          toast.error(res?.message);
        }
      })
      .catch((error: any) => {
        return error;
      })
      .finally(() => {
        // setFileLoaders((prev) => ({ ...prev, [type]: false }));
      });
  }
  return (<>
    <div className="login-form w-100 px-0 position-relative">
      {loader ? <CompoLoader /> : null}
      <div className="custom-title my-auto font-bold mb-2">
        Business Details
      </div>
      <p className="font-14 mb-1">Please enter your business details</p>
      <CommonScrollbar height={"60vh"}>
        <Row className="me-2">
          {" "}
          <Col lg={12} className="">
            <div className="mb-2">
              <RequiredLabel isRequired={true}>
                Choose your profile
              </RequiredLabel>
              <Select
                dropdownHeight="200px"
                className={
                  (!businessDetailData?.choose_profile && skipButtonClicked) ||
                    isWarning(fields_to_improve, "choose_profile")
                    ? "warning-field"
                    : ""
                }
                options={dropdownData[DROPDOWNTYPES.CHOOSE_PROFILE] || []}
                onChange={(values: any) => {
                  if (values?.length > 0) {
                    handleArrayValueChange(values, "choose_profile");
                  }
                }}
                labelField="label"
                valueField="value"
                name="choose_profile"
                values={
                  businessDetailData?.choose_profile
                    ? [
                      {
                        value: businessDetailData?.choose_profile,
                        label: businessDetailData?.choose_profile,
                      },
                    ]
                    : []
                }
              />

              <ErrorComponent
                title="Please select profile"
                flag={errorFlag && !skipButtonClicked}
                isArray={true}
                data={businessDetailData?.choose_profile}
              />
            </div>
            {businessDetailData?.choose_profile === "Other" && (
              <div className="w-100 mt-2">
                <RequiredLabel isRequired={true}>
                  Other Profile Option{ }
                </RequiredLabel>

                <Form.Control
                  type="text"
                  name="choose_profile_other"
                  placeholder="Enter other profile option"
                  onChange={(e) => {
                    const value = e.target.value;
                    setBussinessDetailData(
                      (prev: BusinessDetailsWantToSaleInterface_NEW) => ({
                        ...prev,
                        choose_profile_other: value,
                      }),
                    );
                  }}
                  className={
                    (!businessDetailData?.choose_profile_other &&
                      skipButtonClicked) ||
                      isWarning(fields_to_improve, "choose_profile_other")
                      ? "warning-field"
                      : ""
                  }
                  value={businessDetailData?.choose_profile_other}
                />

                <ErrorComponent
                  title="Please enter other profile option"
                  flag={errorFlag}
                  isArray={false}
                  data={businessDetailData?.choose_profile_other}
                />
              </div>
            )}

            <div className="mb-2 mt-2">
              <RequiredLabel isRequired={false}>
                Type of Business Being Sold (Online, Franchise, Manufacturing,
                Service, etc.)
              </RequiredLabel>
              <Form.Control
                type="text"
                name="type_of_business_being_sold"
                placeholder="Enter type of business being sold"
                onChange={handleChange}
                value={businessDetailData?.type_of_business_being_sold}
                className={
                  isWarning(fields_to_improve, "type_of_business_being_sold")
                    ? "warning-field"
                    : ""
                }
              />
              {/* <ErrorComponent
                title="Please enter type of business being sold"
                flag={errorFlag}
                isArray={false}
                data={businessDetailData?.type_of_business_being_sold}
              /> */}
            </div>

            <div className="mb-2 col-lg-6">
              <RequiredLabel isRequired={false}>
                Number Of Employee
              </RequiredLabel>

              <Select
                dropdownHeight="200px"
                // className="multi-select"
                options={dropdownData[DROPDOWNTYPES.NO_OF_EMPLOYEES] || []}
                onChange={(values: any) => {
                  if (values?.length > 0) {
                    handleArrayValueChange(values, "no_of_employee");
                  }
                }}
                labelField="label"
                valueField="value"
                name="no_of_employee"
                values={
                  businessDetailData?.no_of_employee !== ""
                    ? [
                      {
                        value: businessDetailData?.no_of_employee,
                        label: businessDetailData?.no_of_employee,
                      },
                    ]
                    : []
                }
                className={
                  isWarning(fields_to_improve, "no_of_employee")
                    ? "warning-field"
                    : ""
                }
              />
              {/* <ErrorComponent
                title="Please select number of employee"
                flag={errorFlag}
                isArray={true}
                data={businessDetailData?.no_of_employee}
              /> */}
            </div>
            <div className="mb-4 ">
              <RequiredLabel isRequired={false}>
                Tangible And Intangible Assets Owned By Business
              </RequiredLabel>

              <Form.Control
                type="text"
                placeholder="Enter Assets Owned By Business "
                name="tangible_intangible_assets"
                value={businessDetailData?.tangible_intangible_assets}
                onChange={handleChange}
                className={
                  isWarning(fields_to_improve, "tangible_intangible_assets")
                    ? "warning-field"
                    : ""
                }
              />
              {/* <ErrorComponent
                title="Please enter assets owned by business"
                flag={errorFlag}
                isArray={false}
                data={businessDetailData?.tangible_intangible_assets}
              /> */}
            </div>

            {/* <div className="d-flex flex-nowrap gap-1"> */}
            <div className="mb-2 col-lg-12 flex-fill">
              <RequiredLabel isRequired={false}>
                EBITDA/Operating Profit Margin(%)
              </RequiredLabel>

              <CurrencyInputField
                placeHolder="Enter EBITDA margin (e.g.12.5)"
                id="ebitda"
                suffix="%"
                maxLength={3}
                value={businessDetailData?.ebitda}
                setValue={(value: string) => {
                  handleChangeCurrency("ebitda", value);
                }}
                className={
                  isWarning(fields_to_improve, "ebitda") ? "warning-field" : ""
                }
              />

              {/* <ErrorComponent
                title="Please enter EBITDA/Operating profit margin"
                flag={errorFlag}
                isArray={false}
                data={businessDetailData?.ebitda}
              /> */}
            </div>
            <div className="mb-2 col-lg-12 flex-fill">
              <RequiredLabel isRequired={false}>
                Revenue (Annual or Last FY)
              </RequiredLabel>

              <CurrencyInputField
                placeHolder="Enter annual revenue"
                id="last_year_annual_revenue"
                prefix="$"
                suffix=""
                value={businessDetailData?.last_year_annual_revenue}
                setValue={(value: string) => {
                  handleChangeCurrency("last_year_annual_revenue", value);
                }}
                className={
                  isWarning(fields_to_improve, "last_year_annual_revenue")
                    ? "warning-field"
                    : ""
                }
              />

              {/* <ErrorComponent
                title="Please enter annual revenue"
                flag={errorFlag}
                isArray={false}
                data={businessDetailData?.last_year_annual_revenue}
              /> */}
            </div>
            {/* </div> */}
            <div className="mb-2 col-lg-12">
              <RequiredLabel isRequired={false}>
                Expected Valuation Of Your Business
              </RequiredLabel>

              <CurrencyInputField
                placeHolder="Enter expected valuation"
                id="expected_valuation"
                prefix="$"
                suffix=""
                value={businessDetailData?.expected_valuation}
                setValue={(value: string) => {
                  handleChangeCurrency("expected_valuation", value);
                }}
                className={
                  isWarning(fields_to_improve, "expected_valuation")
                    ? "warning-field"
                    : ""
                }
              />
              {/* 
              <ErrorComponent
                title="Please enter expected valuation"
                flag={errorFlag}
                isArray={false}
                data={businessDetailData?.expected_valuation}
              /> */}
            </div>
            <div className="mb-4 ">
              <RequiredLabel isRequired={false}>
                Valuation Justification (Brief Rationale Or Method Used)
              </RequiredLabel>
              <Form.Control
                type="text"
                placeholder="Enter valuation justification"
                name="valuation_justification"
                value={businessDetailData?.valuation_justification}
                onChange={handleChange}
                className={
                  isWarning(fields_to_improve, "valuation_justification")
                    ? "warning-field"
                    : ""
                }
              />
            </div>
            <div className="mb-4 ">
              <RequiredLabel isRequired={false}>
                Assets Included In Sale (Inventory, IP, Real Estate, Equipment,
                etc.)
              </RequiredLabel>
              <Form.Control
                type="text"
                placeholder="Enter assets included in sale"
                name="assets_included_in_sale"
                value={businessDetailData?.assets_included_in_sale}
                onChange={handleChange}
                className={
                  isWarning(fields_to_improve, "assets_included_in_sale")
                    ? "warning-field"
                    : ""
                }
              />
            </div>
            <div className="mb-4 ">
              <RequiredLabel isRequired={false}>
                Existing Loan & Liabilities
              </RequiredLabel>
              <Form.Control
                type="text"
                placeholder="Enter existing loan & liabilities"
                name="loan_and_liability"
                value={businessDetailData?.loan_and_liability}
                onChange={handleChange}
                className={
                  isWarning(fields_to_improve, "loan_and_liability")
                    ? "warning-field"
                    : ""
                }
              />
              {/* <ErrorComponent
                title="Please enter existing loan & liabilities"
                flag={errorFlag}
                isArray={false}
                data={businessDetailData?.loan_and_liability}
              /> */}
            </div>
            <div className="mb-2 ">
              <RequiredLabel isRequired={false}>Type Of Sale</RequiredLabel>

              <Select
                dropdownHeight="200px"
                className={
                  isWarning(fields_to_improve, "type_of_sale")
                    ? "warning-field"
                    : ""
                }
                options={dropdownData[DROPDOWNTYPES.TYPE_OF_SALE] || []}
                onChange={(values: any) => {
                  if (values?.length > 0) {
                    handleArrayValueChange(values, "type_of_sale");
                  }
                }}
                labelField="label"
                valueField="value"
                name="type_of_sale"
                values={
                  businessDetailData?.type_of_sale
                    ? [
                      {
                        value: businessDetailData?.type_of_sale,
                        label: businessDetailData?.type_of_sale,
                      },
                    ]
                    : []
                }
              />
              {/* <ErrorComponent
                title="Please select type of sale"
                flag={errorFlag}
                isArray={true}
                data={businessDetailData?.type_of_sale}
              /> */}
            </div>
            <div className="mb-2">
              <RequiredLabel isRequired={false}>Buyer Preference</RequiredLabel>

              <Select
                dropdownHeight="200px"
                className={
                  isWarning(fields_to_improve, "buyer_preference")
                    ? "warning-field"
                    : ""
                }
                options={dropdownData[DROPDOWNTYPES.BUYER_PREFERENCE] || []}
                onChange={(values: any) => {
                  if (values?.length > 0) {
                    handleArrayValueChange(values, "buyer_preference");
                  } else {
                    handleArrayValueChange([], "buyer_preference");
                  }
                }}
                labelField="label"
                valueField="value"
                clearable={
                  businessDetailData?.buyer_preference !== "" &&
                  businessDetailData?.buyer_preference !== null
                }
                name="buyer_preference"
                values={
                  businessDetailData?.buyer_preference
                    ? [
                      {
                        value: businessDetailData?.buyer_preference,
                        label: businessDetailData?.buyer_preference,
                      },
                    ]
                    : []
                }
              />
              {/* <ErrorComponent
                title="Please select buyer preference"
                flag={errorFlag}
                isArray={true}
                data={businessDetailData?.buyer_preference}
              /> */}
            </div>
            <div className="d-flex gap-1 w-100 justify-content-between">
              <div className="mb-2 w-50">
                <RequiredLabel isRequired={true}>Asking Price</RequiredLabel>

                <CurrencyInputField
                  placeHolder="Enter asking price"
                  id="asking_price"
                  prefix="$"
                  suffix=""
                  value={businessDetailData?.asking_price}
                  setValue={(value: string) => {
                    handleChangeCurrency("asking_price", value);
                  }}
                  className={
                    (!businessDetailData?.asking_price && skipButtonClicked) ||
                      isWarning(fields_to_improve, "asking_price")
                      ? "warning-field"
                      : ""
                  }
                />
                <ErrorComponent
                  title="Please enter asking price"
                  flag={errorFlag && !skipButtonClicked}
                  isArray={false}
                  data={businessDetailData?.asking_price}
                />
              </div>
              <div className="mb-2 col-lg-6">
                <RequiredLabel isRequired={false}>
                  Deal Timeline Expectation
                </RequiredLabel>

                <Select
                  dropdownHeight="200px"
                  // className="multi-select"
                  options={
                    dropdownData[DROPDOWNTYPES.DEAL_TIMELINE_EXPECTATION] || []
                  }
                  onChange={(values: any) => {
                    if (values?.length > 0) {
                      handleArrayValueChange(
                        values,
                        "deal_timeline_expectation",
                      );
                    }
                  }}
                  labelField="label"
                  valueField="value"
                  name="buyer_preference"
                  values={
                    businessDetailData?.deal_timeline_expectation
                      ? [
                        {
                          value:
                            businessDetailData?.deal_timeline_expectation,
                          label:
                            businessDetailData?.deal_timeline_expectation,
                        },
                      ]
                      : []
                  }
                  className={
                    isWarning(fields_to_improve, "deal_timeline_expectation")
                      ? "warning-field"
                      : ""
                  }
                />
                {/* <ErrorComponent
                  title="Please select buyer preference"
                  flag={errorFlag && !skipButtonClicked}
                  isArray={true}
                  data={businessDetailData?.buyer_preference}
                /> */}
              </div>
            </div>

            <div className="mb-2 w-100 text-start">
              <RequiredLabel isRequired={false}>
                Open to Earn-Out or Deferred Payment?
              </RequiredLabel>

              <div className="d-flex gap-3 mt-1">
                <div
                  className={`${isWarning(fields_to_improve, "earn_out_deferred_payment")
                    ? "communication-pill active-warning"
                    : ""
                    }`}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="earn_out_deferred_payment"
                    id="yes"
                    value="1"
                    checked={
                      businessDetailData?.earn_out_deferred_payment === "1" ||
                      businessDetailData?.earn_out_deferred_payment === 1
                    }
                    onChange={(e) =>
                      setBussinessDetailData(
                        (pre: BusinessDetailsWantToSaleInterface_NEW) => ({
                          ...pre,
                          earn_out_deferred_payment: e.target.value,
                        }),
                      )
                    }
                  />
                  <label className="form-check-label" htmlFor="yes">
                    Yes
                  </label>
                </div>

                <div
                  className={` ${isWarning(fields_to_improve, "earn_out_deferred_payment")
                    ? "communication-pill active-warning"
                    : ""
                    }`}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="earn_out_deferred_payment"
                    id="no"
                    value="0"
                    checked={
                      businessDetailData?.earn_out_deferred_payment === "0" ||
                      businessDetailData?.earn_out_deferred_payment === 0
                    }
                    onChange={(e) =>
                      setBussinessDetailData(
                        (pre: BusinessDetailsWantToSaleInterface_NEW) => ({
                          ...pre,
                          earn_out_deferred_payment: e.target.value,
                        }),
                      )
                    }
                  />
                  <label className="form-check-label" htmlFor="no">
                    No
                  </label>
                </div>
              </div>
              {/* <ErrorComponent
                title="Please select "
                flag={errorFlag}
                isArray={false}
                data={businessDetailData?.earn_out_deferred_payment}
              /> */}
            </div>
            <div className="mb-2 w-100 text-start">
              <RequiredLabel isRequired={false}>
                Is Team Willing To Stay Post-Sale?
              </RequiredLabel>

              <div className="d-flex gap-3 mt-1 ">
                <div
                  className={` ${isWarning(fields_to_improve, "team_willing_post_sale")
                    ? "communication-pill active-warning"
                    : ""
                    }`}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="team_willing_post_sale"
                    id="yes_team_will"
                    value="1"
                    checked={
                      businessDetailData?.team_willing_post_sale === "1" ||
                      businessDetailData?.team_willing_post_sale === 1
                    }
                    onChange={(e) =>
                      setBussinessDetailData(
                        (pre: BusinessDetailsWantToSaleInterface_NEW) => ({
                          ...pre,
                          team_willing_post_sale: e.target.value,
                        }),
                      )
                    }
                  />
                  <label className="form-check-label" htmlFor="yes_team_will">
                    Yes
                  </label>
                </div>

                <div
                  className={`${isWarning(fields_to_improve, "team_willing_post_sale")
                    ? "communication-pill active-warning"
                    : ""
                    }`}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="team_willing_post_sale"
                    id="no_team_will"
                    value="0"
                    checked={
                      businessDetailData?.team_willing_post_sale === "0" ||
                      businessDetailData?.team_willing_post_sale === 0
                    }
                    onChange={(e) =>
                      setBussinessDetailData(
                        (pre: BusinessDetailsWantToSaleInterface_NEW) => ({
                          ...pre,
                          team_willing_post_sale: e.target.value,
                        }),
                      )
                    }
                  />
                  <label className="form-check-label" htmlFor="no_team_will">
                    No
                  </label>
                </div>
                <div
                  className={`${isWarning(fields_to_improve, "team_willing_post_sale")
                    ? "communication-pill active-warning"
                    : ""
                    }`}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="team_willing_post_sale"
                    id="Negotiable_team_will"
                    value="2"
                    checked={
                      businessDetailData?.team_willing_post_sale === "2" ||
                      businessDetailData?.team_willing_post_sale === 2
                    }
                    onChange={(e) =>
                      setBussinessDetailData(
                        (pre: BusinessDetailsWantToSaleInterface_NEW) => ({
                          ...pre,
                          team_willing_post_sale: e.target.value,
                        }),
                      )
                    }
                  />
                  <label
                    className="form-check-label"
                    htmlFor="Negotiable_team_will"
                  >
                    Negotiable
                  </label>
                </div>
              </div>
              {/* <ErrorComponent
                title="Please select "
                flag={errorFlag}
                isArray={false}
                data={businessDetailData?.team_willing_post_sale}
              /> */}
            </div>

            <div className="mb-2 w-100 text-start">
              <RequiredLabel isRequired={false}>
                Owner involvment level
              </RequiredLabel>

              <div className="d-flex gap-1 mt-1 ">
                <div
                  className={` ${isWarning(fields_to_improve, "owner_involvment_level")
                    ? "communication-pill  active-warning"
                    : ""
                    }`}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="owner_involvment_level"
                    id="daily"
                    value="1"
                    checked={
                      businessDetailData?.owner_involvment_level === "1" ||
                      businessDetailData?.owner_involvment_level === 1
                    }
                    onChange={(e) =>
                      setBussinessDetailData(
                        (pre: BusinessDetailsWantToSaleInterface_NEW) => ({
                          ...pre,
                          owner_involvment_level: e.target.value,
                        }),
                      )
                    }
                  />
                  <label className="form-check-label" htmlFor="daily">
                    Daily
                  </label>
                </div>

                <div
                  className={`${isWarning(fields_to_improve, "owner_involvment_level")
                    ? "communication-pill active-warning"
                    : ""
                    }`}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="owner_involvment_level"
                    id="None"
                    value="0"
                    checked={
                      businessDetailData?.owner_involvment_level === "0" ||
                      businessDetailData?.owner_involvment_level === 0
                    }
                    onChange={(e) =>
                      setBussinessDetailData(
                        (pre: BusinessDetailsWantToSaleInterface_NEW) => ({
                          ...pre,
                          owner_involvment_level: e.target.value,
                        }),
                      )
                    }
                  />
                  <label className="form-check-label" htmlFor="None">
                    None
                  </label>
                </div>
                <div
                  className={`${isWarning(fields_to_improve, "owner_involvment_level")
                    ? "communication-pill active-warning"
                    : ""
                    }`}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="owner_involvment_level"
                    id="Strategic"
                    value="2"
                    checked={
                      businessDetailData?.owner_involvment_level === "2" ||
                      businessDetailData?.owner_involvment_level === 2
                    }
                    onChange={(e) =>
                      setBussinessDetailData(
                        (pre: BusinessDetailsWantToSaleInterface_NEW) => ({
                          ...pre,
                          owner_involvment_level: e.target.value,
                        }),
                      )
                    }
                  />
                  <label className="form-check-label" htmlFor="Strategic">
                    Strategic
                  </label>
                </div>
              </div>
              {/* <ErrorComponent
                title="Please select "
                flag={errorFlag}
                isArray={false}
                data={businessDetailData?.owner_involvment_level}
              /> */}
            </div>
            <div className="mb-2 w-100 text-start">
              <RequiredLabel isRequired={false}>
                Would You Offer Post-Sale Support or Advisory?
              </RequiredLabel>

              <div className="d-flex gap-3 mt-1 ">
                <div
                  className={`${isWarning(fields_to_improve, "offer_post_sale")
                    ? "communication-pill active-warning"
                    : ""
                    }`}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="offer_post_sale"
                    id="yes_owner"
                    value="1"
                    checked={
                      businessDetailData?.offer_post_sale === "1" ||
                      businessDetailData?.offer_post_sale === 1
                    }
                    onChange={(e) =>
                      setBussinessDetailData(
                        (pre: BusinessDetailsWantToSaleInterface_NEW) => ({
                          ...pre,
                          offer_post_sale: e.target.value,
                        }),
                      )
                    }
                  />
                  <label className="form-check-label" htmlFor="yes_owner">
                    Yes
                  </label>
                </div>

                <div
                  className={`${isWarning(fields_to_improve, "offer_post_sale")
                    ? "communication-pill active-warning"
                    : ""
                    }`}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="offer_post_sale"
                    id="no_owner"
                    value="0"
                    checked={
                      businessDetailData?.offer_post_sale === "0" ||
                      businessDetailData?.offer_post_sale === 0
                    }
                    onChange={(e) =>
                      setBussinessDetailData(
                        (pre: BusinessDetailsWantToSaleInterface_NEW) => ({
                          ...pre,
                          offer_post_sale: e.target.value,
                        }),
                      )
                    }
                  />
                  <label className="form-check-label" htmlFor="no_owner">
                    No
                  </label>
                </div>
              </div>
              {/* <ErrorComponent
                title="Please select "
                flag={errorFlag}
                isArray={false}
                data={businessDetailData?.offer_post_sale}
              /> */}
            </div>

            <div className="d-flex w-100 gap-1">
              <div className="mb-2 w-100">
                <RequiredLabel isRequired={false}>
                  Preferred Location
                </RequiredLabel>
                <Select
                  dropdownHeight="200px"
                  // className="multi-select"
                  options={businessLocationList}
                  searchable={true}
                  labelField="label"
                  valueField="value"
                  name="business_location"
                  className={
                    isWarning(fields_to_improve, "preffered_location")
                      ? "warning-field"
                      : ""
                  }
                  values={
                    businessDetailData?.preffered_location
                      ? [
                        {
                          value: businessDetailData?.preffered_location,
                          label: businessDetailData?.preffered_location,
                          // flag: selectedBL?.flag || ""
                        },
                      ]
                      : []
                  }
                  onChange={(values: any) => {
                    if (values?.length > 0) {
                      handleArrayValueChange(values, "preffered_location");
                    }
                  }}
                  itemRenderer={({ item, methods }) => (
                    <div
                      className="flex items-center gap-2 p-2 cursor-pointer hover:bg-gray-100"
                      onClick={() => methods.addItem(item)}
                    >
                      <img
                        src={item.flag}
                        width="24"
                        height="24"
                        className="me-2"
                      />
                      <span>{item.label}</span>
                    </div>
                  )}
                />

                {/* <ErrorComponent
                  title="Please select preferred location"
                  flag={errorFlag}
                  isArray={false}
                  data={businessDetailData?.preffered_location}
                /> */}
              </div>
              <div className="mb-2 w-50 ">
                <RequiredLabel isRequired={false}>
                  Strategic assets
                </RequiredLabel>
                <Select
                  dropdownHeight="200px"
                  options={dropdownData[DROPDOWNTYPES.STRATEGIC_ASSETS] || []}
                  onChange={(values: any) => {
                    if (values?.length > 0) {
                      handleArrayValueChange(values, "strategic_assets");
                    }
                  }}
                  labelField="label"
                  valueField="value"
                  name="strategic_assets"
                  className={
                    isWarning(fields_to_improve, "strategic_assets")
                      ? "warning-field"
                      : ""
                  }
                  values={
                    businessDetailData?.strategic_assets
                      ? [
                        {
                          value: businessDetailData?.strategic_assets,
                          label: businessDetailData?.strategic_assets,
                        },
                      ]
                      : []
                  }
                />
                {/* <ErrorComponent
                  title="Please select strategic assets"
                  flag={errorFlag}
                  isArray={true}
                  data={businessDetailData?.strategic_assets}
                /> */}
              </div>
            </div>
            <div className="mb-2 w-100">
              <RequiredLabel isRequired={false}>
                Top Keywords for Matchmaking(Max 5)
              </RequiredLabel>
              <InfoIconForKeyword />

              <TagsInput
                inputProps={{
                  placeholder: "Please hit ENTER to save keyword",
                  className: isWarning(fields_to_improve, "top_keywords")
                    ? "warning-field form-control react-tagsinput-input "
                    : "form-control react-tagsinput-input ",
                }}
                value={
                  businessDetailData?.top_keywords?.length > 0
                    ? businessDetailData?.top_keywords?.map(
                      (ele: any) => ele?.title,
                    )
                    : []
                }
                preventSubmit
                addOnPaste
                onlyUnique
                onChange={(tags: string[]) => {
                  if (tags?.length > 5) {
                    toast.warn("Max 5 keywords allowed!");
                    return;
                  }
                  setBussinessDetailData(
                    (prev: BusinessDetailsWantToSaleInterface_NEW) => ({
                      ...prev,
                      top_keywords: tags.map((tag) => ({ title: tag })),
                    }),
                  );
                }}
              />
              {/* <ErrorComponent
                title="Please enter at least one keyword"
                flag={errorFlag}
                isArray={true}
                data={businessDetailData?.top_keywords}
              /> */}
            </div>

            <div className="mb-2 d-flex gap-2">
              <Button
                className={
                  from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS"
                    ? "btn btn-primary w-100"
                    : "btn btn-primary w-50"
                }
                type="button"
                id="save_business_details"
                onClick={() => {
                  setSkipButtonClicked(false);
                  handleSaveBusinessDetails(false);
                }}
              >
                {" "}
                {from && from === "REVIEW"
                  ? t("Register.save")
                  : t("Register.continue")}
              </Button>
              {from !== "REVIEW" && from !== "FROM_PROFILE_ANALYSIS" && (
                <Button
                  className="btn btn-secondary w-50"
                  type="button"
                  id="skip_basic_details"
                  onClick={() => {
                    setSkipButtonClicked(true);
                    handleSaveBusinessDetails(true);
                  }}
                  disabled={apiCallTriggered}
                >
                  Skip
                </Button>
              )}
            </div>
          </Col>
        </Row>
      </CommonScrollbar>
    </div>
  </>
  );
};
export default BusinessDetails_WantToSell;
